import React, { lazy } from 'react';

const AIAssistant = lazy(() =>
  import('../AIAssistantPage').then(module => ({
    default: module.AI_AssistantPage,
  })),
);

const aiAssistantRoutes = [
  {
    props: { exact: true, path: '/ai-assistant' },
    component: <AIAssistant />,
  },
];
export default aiAssistantRoutes;
